// imports
import * as THREE from "three"

// classes
import Experience from "./Experience"

export default class Overlay
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.shaders = this.experience.shaders

        this.setOverlay()
        this.setLoadingBar()
    }

    setOverlay()
    {

        this.overlayVertex = this.shaders.overlayVertex
        this.overlayFragment = this.shaders.overlayFragment

        this.overlayGeometry = new THREE.PlaneGeometry( 2, 2, 5, 5 )
        this.overlayMaterial = new THREE.RawShaderMaterial(
        {
            uniforms:
            {
                uAlpha: { value: 1.0 }
            },

            vertexShader: this.overlayVertex,
            fragmentShader: this.overlayFragment,

            depthTest: false,
            transparent: true,
        } )

        this.overlay = new THREE.Mesh( this.overlayGeometry, this.overlayMaterial ) 
        this.scene.add( this.overlay )
    }

    setLoadingBar()
    {
        this.loadingBarVertex = this.shaders.loadingBarVertex
        this.loadingBarFragment = this.shaders.loadingBarFragment

        this.loadingBarGeometry = new THREE.PlaneGeometry( 0.01, 0.003, 5, 5 )
        this.loadingBarMaterial = new THREE.RawShaderMaterial(
        {
            vertexShader: this.loadingBarVertex,
            fragmentShader: this.loadingBarFragment,

            side: THREE.DoubleSide,
            transparent: true
        } )

        this.loadingBar = new THREE.Mesh( this.loadingBarGeometry, this.loadingBarMaterial )
        this.scene.add( this.loadingBar )
    }
}